import { createSelector } from "reselect"

export function loadedvslaMembers(state = [], action) {
  switch (action.type) {
    case "LOAD_LOCAL_VSLA_MEMBERS":
      const mapper = {};
      [...state, ...action.payload].forEach(item => {
        mapper[item.pubkey] = item
      });
      return Object.values(mapper) // remove duplicates

    case "LOADED_VSLA_MEMBERS":
      return action.payload
    case "CREATE_MEMBER_ERROR":
      return state.map(member =>
        member.cacheId === action.payload.tempId
          ? { ...member, syncStatus: 'error', error: action.payload.error }
          : member
      );
    case "UPDATE_MEMBER_STATUS":
      return state.map(member =>
        member.pubkey === action.payload.tempId
          ? {
            ...member,
            syncStatus: action.payload.syncStatus
          }
          : member
      );
    case "REMOVE_MEMBER":
      const key = action.payload.key;
      const value = action.payload.value;
      if (!key && !value) {
        return state
      }
      const updated = state.filter(m => m?.[key] !== value)
      return updated
    default:
      return state
  }
}

export function memberToEdit(state = null, action) {
  switch (action.type) {
    case 'UPDATE_MEMBER_TO_EDIT':
      return action.payload
    case 'CLEAR_MEMBER_TO_EDIT':
      return null
    default:
      return state
  }
}

export function vlsaMembersLoadingStarted(state = false, action) {
  switch (action.type) {
    case "VSLA_MEM_LOAD_START":
      return action.isloading
    default:
      return state
  }
}

export function vlsaMembersLoadingError(state = false, action) {
  switch (action.type) {
    case "VSLA_MEM_LOAD_ERROR":
      return action.error
    default:
      return state
  }
}

export const loadVslaMembers = (state) => state.loadedvslaMembers

export const SelectVslaMembers = createSelector(loadVslaMembers, (members) => {
  return members.filter(
    (member) => member?.status === "Active" && member?.blockchain_wallet_id !== null,
  )
})
